export default "__VITE_ASSET__6d84205f__"